import _objectSpread from "C:/Office/_LIVE/AgyagosLanyBFBASE/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "C:/Office/_LIVE/AgyagosLanyBFBASE/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Helpers
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CartItem',
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      itemEditorIsVisible: false,
      quantity: 1,
      maxQuantity: 99,
      adjustmentError: false,
      validateCartStock: false
    };
  },
  fetch: function fetch() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $swell, item, product, maxQuantity;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $swell = _this.$swell, item = _this.item; // Fetch product

              _context.next = 3;
              return $swell.products.get(item.product.id);

            case 3:
              product = _context.sent;
              maxQuantity = get(product, 'content.maxQuantity');
              maxQuantity = !maxQuantity ? 99 : typeof maxQuantity === 'string' ? Number(maxQuantity) : 99;
              maxQuantity = !isNaN(maxQuantity) ? maxQuantity : 99;
              _this.maxQuantity = maxQuantity;
              _this.quantity = item.quantity;
              _this.validateCartStock = $swell.settings.get('cart.validateStock');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapState(['currency'])), {}, {
    previewImage: function previewImage() {
      return get(this, 'item.variant.images.0') || get(this, 'item.product.images.0');
    },
    billingSchedule: function billingSchedule() {
      var purchaseOption = this.item.purchaseOption;

      if (purchaseOption && purchaseOption.type === 'subscription') {
        return purchaseOption.billingSchedule;
      }

      return null;
    },
    intervalCount: function intervalCount() {
      if (this.billingSchedule) {
        return this.billingSchedule.intervalCount;
      }

      return null;
    },
    subscriptionInterval: function subscriptionInterval() {
      if (this.billingSchedule) {
        return this.$t("products.slug.purchaseOptions.interval.".concat(this.billingSchedule.interval, ".short"));
      }

      return null;
    }
  }),
  watch: {
    // Update qty if item has recently been
    item: function item(val) {
      this.quantity = val.quantity;
    },
    quantity: function quantity(val) {
      this.$store.dispatch('updateCartItem', {
        id: this.item.id,
        fieldsToUpdate: {
          quantity: val
        }
      });
    }
  },
  methods: {
    removeItem: function removeItem() {
      this.$store.dispatch('removeCartItem', this.item);
    }
  }
};